module.exports = __webpack_public_path__ + "img/dora-logo.f79ffedb.svg";